import React from 'react'
import { Link } from 'react-router-dom';
import { Button } from '../components/button'

const LandingPage = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh',
            fontSize: '3rem',
        }}>
            <h1>Welcome</h1>
            <Link to="/register">
                <Button>
                    Register
                </Button>
            </Link>
            <Link style={{ marginTop: '3rem' }} to="/account">
                <Button variant="secondary">
                    account
                </Button>
            </Link>
            <Link style={{ marginTop: '3rem' }} to="/admin/dashboard">
                <Button variant="secondary">
                    admin
                </Button>
            </Link>
        </div>
    )
}

export default LandingPage
